<script lang="ts" setup>
/* Panel Enable Push Notifications Component
 *
 * This component renders a panel prompting the user to enable push notifications.
 */

const emits = defineEmits<{
    click: ['activate' | 'deactivate']
}>()

</script>

<template>
    <div class="notifications-app row">
        <div class="columns">
            <div class="panel">
                <div class="row">
                    <div class="columns">
                        <div class="headline">
                            System Mitteilungen
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="columns">
                        <div class="description">
                            Werde über neue Daten oder andere wichtige Ereignisse informiert, auch wenn du
                            nicht aktiv
                            in der Webseite bist.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="columns">
                        <div class="description">
                            Der Service nutzt Dienste von Drittanbietern, um die Mitteilungen zuzustellen.<br />

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="columns">
                        <div class="description">
                            <a href="/datenschutz.htm">Mehr Informationen hier</a>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="columns">
                        <div class="lan:flex lan:flex-col lan:gap-2.5 lan:@container">
                            <!-- enough space in container-->
                            <div class="button primary lan:m-0 lan:hidden lan:@min-[225px]:block lan:select-none"
                                @click="$emit('click', 'activate')"><i class="fa-regular fa-bell"></i>Mitteilungen
                                aktivieren</div>
                            <div class="button primary lan:m-0 lan:hidden lan:@min-[225px]:block lan:select-none"
                                @click="$emit('click', 'deactivate')"><i class="fa-regular fa-bell-slash"></i>
                                Mitteilungen deaktivieren</div>


                            <!-- not enough space in button-->
                            <div class="button primary lan:m-0 lan:block lan:@min-[225px]:hidden lan:select-none"
                                @click="$emit('click', 'activate')"><i class="fa-regular fa-bell"></i> Aktivieren
                            </div>
                            <div class="button primary lan:m-0 lan:block lan:@min-[225px]:hidden lan:select-none"
                                @click="$emit('click', 'deactivate')"><i class="fa-regular fa-bell-slash"></i>
                                Deaktivieren</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>